
const Footer=(props:any)=>{

  return (
    <div id="footer">
      <div className="footer_con">
        
      </div>
    </div>
  );
};

export default Footer;